import type { PricedZonedSelection } from "@/lib/menu/zonedBuilder"

/**
 * Las filas de modificador que un armado por zonas deja EN EL CARRITO.
 *
 * Existe compartida porque el mismo mapeo vivía copiado en los tres modales que montan
 * el armador (kiosko, POS y microsite) — y los tres traían el mismo bug: escribían
 * `price_delta: 0` "porque el servidor recotiza". El servidor sí recotiza, pero
 * `calculateOrderTotals` —el único motor de totales del cliente— suma exactamente ese
 * campo. Con 0 el carrito, la propina y el "Pagar ahora" enseñaban la pizza SIN extras
 * y la tarjeta pagaba otra cosa (Q Pizzas, orden 001 del 24-ago: pantalla $46.61,
 * cargo $55.27).
 *
 * 🔴 Esto NO abre la puerta a que el cliente ponga el precio: `ZonedSelectionInput`
 * (lib/menu/zonedQuote.ts) ni siquiera tiene campo `price_delta`. El servidor cotiza
 * cada fila contra la rejilla y sus propios hechos, y lo que llegue acá le da igual.
 * Este número es SOLO para que la pantalla diga la verdad.
 */
export type ZonedCartRow = {
  modifier_group_id: string
  modifier_option_id: string
  group_name: string
  option_name: string
  price_delta: number
  quantity: number
  /** El armador no ofrece "al lado" en una fila zoneada: siempre false, como antes. */
  serve_on_side: false
  zone: string
  is_removal: boolean
}

/** Lo que cada modal sabe de una opción del armador. */
export type ZonedRowOption = {
  groupId: string
  name: string
  /** Rótulo del grupo. El kiosko y el microsite no lo llevan en su línea: "" es válido. */
  groupName?: string
}

export function zonedCartRows(
  priced: readonly PricedZonedSelection[],
  optionById: (optionId: string) => ZonedRowOption | undefined
): ZonedCartRow[] {
  return priced.map((sel) => {
    const o = optionById(sel.optionId)
    return {
      modifier_group_id: o?.groupId ?? "",
      modifier_option_id: sel.optionId,
      group_name: o?.groupName ?? "",
      option_name: o?.name ?? "",
      // Centavos → dólares. `priceDeltaCents` es entero, así que la división es exacta
      // a dos decimales y no arrastra el error de coma flotante que tendría multiplicar
      // precios sueltos.
      price_delta: sel.priceDeltaCents / 100,
      quantity: sel.quantity,
      serve_on_side: false,
      zone: sel.zone,
      is_removal: sel.isRemoval,
    }
  })
}
